import TimeField from 'components/form-fields/formik/TimeField';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { buildFormPath } from 'subdomains/cpo/utils/formpath';
import { Form, Segment } from 'semantic';

type Props = {
  basePath: string;
};

export const TimeOfDayRestriction = (props: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Form.Field>
        <label>{t('restrictions.timeOfDay.label', 'Time of the day')}</label>
      </Form.Field>
      <Segment>
        <Form.Group>
          <TimeField
            name={buildFormPath('start', props.basePath)}
            label={t('tariff.restrictions.startAt', 'Start at')}
          />

          <TimeField
            name={buildFormPath('end', props.basePath)}
            label={t('tariff.restrictions.endAt', 'End at')}
          />
        </Form.Group>
      </Segment>
    </>
  );
};
